import { LoadState } from "../../constants/enums";
import {
  ICrossroadsLead,
  ICrossroadsLeadsState,
  ICrossroadsMembership,
  ICrossroadsInvoice,
  ICrossroadsVehicle,
  ICustomerConnectionDetails
} from "./CrossroadsLeads.types";

export const InitialCrossroadsLeadsState: ICrossroadsLead = {
  crossroads_lead_id: 0,
  crossroads_lead_unique_id: 0,
  crossroads_lead_uuid: "",
  assign_to_id: null,
  assign_to_uuid: "",
  assign_to_name: "",
  user_name: "",
  contact_number: "",
  email_id: "",
  source: "B2BPANEL",
  type: null,
  campaign_name: "PANEL LEAD",
  state: "",
  city: "",
  area: "",
  pin_code: "",
  address: "",
  gstin: "",
  vehicle_no: "",
  make_name: "",
  model_name: "",
  registration_year: "",
  package_name: null,
  package_uuid: null,
  package_id: null,
  package_price: 0,
  package_period: 0,
  package_services: 0,
  package_period_type: null,
  payment_amount: 0,
  created_by: 0,
  sales_lead_id: 0,
  sales_lead_uuid: "",
  sales_lead_name: "",
  agent_id: 0,
  agent_uuid: "",
  agent_name: "",
  manager_id: 0,
  manager_uuid: "",
  manager_name: "",
  created_from: "",
  fe_id: 0,
  promo_code: "",
  rsa_promocode_uuid: null,
  referral_code: "",
  partner_id: 0,
  partner_uuid: null,
  partner_name: "",
  gst_percentage: 0,
  gst_amount: 0,
  iteration: 0,
  payment_mode: "",
  payment_status: "",
  membership_code: "",
  payment_date: null,
  primary_disposition: null,
  secondary_disposition: null,
  disposition: null,
  disposition_uuid: null,
  comment: null,
  description: "",

  follow_up_notes: null,
  additional_details: null,
  status: "ONGOING",
  remarks: "",
  company_outlet_uuid: "",
  // Followup fields
  follow_up_date: null,
  followup_time_slot: null,
  communication_type: "",
  call_status: "",
  total_service: 0,
  used_service: 0,
  remain_service: 0,
  dnd: 0,
  // read-only / audit
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  shift: "",
  create_ts: new Date().toISOString(),
  insert_ts: new Date().toISOString(),
};

export const InitialCrossroadsLeadsReduxState: ICrossroadsLeadsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  data: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  followUpHistory: {
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  memberships: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  invoices: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  vehicles: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  recordCounts: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  customerConnectionDetails: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
};

export const InitialCrossroadsMembershipState: ICrossroadsMembership = {
  membership_code: "",
  membership_start_date: "",
  membership_expiry_date: "",
  user_id: 0,
  user_subcription_id: 0,
  user_subscription_dim_id: 0,
  contact_number: "",
  vehicle_number: "",
  maker_name: "",
  model_name: "",
  registration_year: 0,
  state: "",
  city: "",
  area: "",
  address: "",
  gstin_no: "",
  partner_id: 0,
  status: "",
  comment: "",
  insert_dt: "",
  user_profile_id: 0,
  user_name: "",
  email_id: "",
  father_name: "",
  gender: "",
  mobile_number: "",
  pin: "",
  services_id: 0,
  total_services: 0,
  used_services: 0,
  remain_services: 0,
  package_id: 0

};

export const InitialCrossroadsInvoiceState: ICrossroadsInvoice = {
  financial_year: "",
  invoice_number: 0,
  payment_log_id: 0,
  invoice_dim_id: 0,
  invoice_id: 0,
  product_description: "",
  hsn_code: "",
  invoice_type: null,
  gst_percentage: 0,
  quantity: 0,
  rate: 0,
  discount: 0,
  taxable_amount: 0,
  gst_amount: 0,
  total: 0,
  bill_name: "",
  bill_address: "",
  bill_gstin: "",
  bill_state: "",
  ship_name: "",
  ship_address: "",
  ship_gstin: "",
  ship_state: "",
  amount_before_tax: 0,
  amount_after_tax: 0,
  status: "",
  remark: "",
  insert_dt: "",
  membership_code: "",
  contact_no: "",
  payment_mode: "",
  vehicle_no: null,
  payment_date: "",
};

export const InitialCrossroadsVehicleState: ICrossroadsVehicle = {
  vehicle_number: "",
  make_name: "",
  model_name: "",
  registration_year: "",
};

export const InitialCustomerConnectionDetailsState: ICustomerConnectionDetails = {
  user_id: 0,
  user_subcription_id: 0,
  user_subscription_dim_id: 0,
  membership_code: "",
  contact_number: "",
  vehicle_number: "",
  maker_name: "",
  model_name: "",
  registration_year: 0,
  state: "",
  city: "",
  area: "",
  address: "",
  gstin_no: "",
  partner_id: 0,
  status: "",
  comment: "",
  insert_dt: "",
  user_profile_id: 0,
  user_name: "",
  email_id: "",
  father_name: "",
  gender: "",
  mobile_number: "",
  pin: "",
  services_id: 0,
  total_services: 0,
  used_services: 0,
  remain_services: 0,
  membership_start_date: "",
  membership_expiry_date: "",
  package_id: 0,
};
